// screenTablet:
export const SCREEN_WIDTH_TABLET = 768; // for sticky navigation
export const NAVIGATION_ANIMATION_DURATION = 250;
export const mainMenuContainer = document.getElementById('zacatek');
export const mainMenuItemsGap = 2 * 12; // gap between menu items (LI padding)
export const mainMenuExtraSpace = 50; // extra space to be sure that menu won't be wrapped
export const FADE_OUT_ANIMATION_TIME = 300; // cas animace fadeOut efektu
export const FADE_IN_ANIMATION_TIME = 10; // cas animace fadeIn efektu
export const VERTICAL_SCROLL_EXTRA_OFFSET = 30; // extra odsazeni pri scrollu na konkretni pozici
